import React, { Component } from 'react';
import axios from 'axios';


class AddAssignment extends Component {
  state = {
    title: '',
    selectedFile: null,
    selectedMainFile: null,
    fileExtension: '',
    isActive: false,
    windowHeight: window.innerHeight - 60,
    error: null,
    loading: false, // Added loading state
  };
  // for the image 
  fileInputRef = React.createRef();










  // start of the handle submition


  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: null });
    const formData = new FormData();
    formData.append('title', this.state.title);
    // if (this.state.selectedMainFile) {
    //   formData.append(, this.state.selectedMainFile);
    // }
    if (this.state.selectedMainFile) {
      // The first argument is the field name your backend expects (e.g., 'file').
      // The second argument is the File object itself.
      // The third optional argument is the filename (which is good practice to include).
      formData.append('file', this.state.selectedMainFile, this.state.selectedMainFile.name);
    }


    try {
      const course_id = this.props.course_id
      const courseId = parseInt(course_id, 10);
      const accessToken = localStorage.getItem('accessToken');
      const response = await axios.post(`https://api.geoinfoacademy.com/api/courses/${courseId}/capstones/`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log('API response:', response);
      this.setState({
        title: '',
        selectedFile: null,
        selectedMainFile: null,
      });
      if (this.props.onRefresh) { // Changed from onDocumentSubmit to onRefresh
        this.props.onRefresh(); // Call the callback to signal the parent
    }
      const formdisplay = document.querySelector(".dash_add_course_cover.addassignment")
      formdisplay.style.display = "none"
    } catch (error) {
      console.error('Error submitting form:', error);

    }
    finally {
      this.setState({ loading: false }); // Set loading to false after response
    }
  };


  // end for the submition





  handleFileChange = (event) => {
    const file = event.target.files[0];
    this.setState({ selectedMainFile: event.target.files[0] });
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.setState({
          selectedFile: e.target.result,
          fileExtension: this.getFileExtension(file.name)
        });
      };
      reader.readAsDataURL(file);
    }
  };


  handleDragOver = (event) => {
    event.preventDefault();
  };

  handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    this.handleFileChange({ target: { files: [file] } });
  };

  handleButtonClick = (e) => {
    e.preventDefault()
    this.fileInputRef.current.click();
  };

  handleCancelImage = (e) => {
    e.preventDefault()
    this.setState({ selectedFile: null }); // Use selectedFile
  };
  getFileExtension = (filename) => {
    const parts = filename.split('.');
    return parts.pop();
  };
  // end of the image




  // the display
  handleOutsideClick = (event) => {
    if (this.node && !this.node.contains(event.target)) {
      this.setState({ isActive: false, });
      const formdisplay = document.querySelector(".dash_add_course_cover.addassignment")
      formdisplay.style.display = "none"
    }

  };
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  handleResize = () => {
    this.setState({ windowHeight: window.innerHeight - 60 });
  };


  render() {
    const { selectedFile, fileExtension } = this.state;
    const { menuCoverWidth } = this.state;
    console.log("this is ad assignment", this.state)

    return (

      <div className="dash_add_course_cover addassignment" style={{ width: `calc(100% - ${menuCoverWidth}px - 3px)`, height: this.state.windowHeight }}>
        <div className="dash_form_container" ref={(node) => (this.node = node)}>
          <h2>Add Assignment</h2>
          <p>Make sure to follow the instruction if any bellow the input </p>
          <form onSubmit={this.handleSubmit} className='add_course_form'>
            <label htmlFor="title">Title</label><br />
            <input type="text" id='title' name="title" value={this.state.title} onChange={this.handleInputChange} placeholder="Input course title" /><br /><br />


            <label htmlFor="file">Upload File</label><br />
            <div className="file-uploader">
              <div className="drop-zone"
                onDragOver={this.handleDragOver}
                onDrop={this.handleDrop}>
                {selectedFile ? (
                  <div className="file-preview">
                    {/* You can display a file preview here based on the file type, if applicable */}
                    <p>File Selected: {selectedFile.name} {selectedFile.name} ({fileExtension})</p>
                    <button onClick={this.handleCancelImage}>Cancel</button>
                  </div>
                ) : (
                  <div className="drop-zone-text">
                    Drag and drop a file here<br />
                    or <button onClick={this.handleButtonClick}>Click to select</button>
                  </div>
                )}
              </div>
              <input
                type="file"
                id='file'
                onChange={this.handleFileChange}
                ref={this.fileInputRef}
                style={{ display: 'none' }}
              />
            </div><br /><br />



            <button type="submit" disabled={this.state.loading}>
              {this.state.loading ? "Uploading..." : "Submit"}
            </button>
          </form>
        </div>
      </div>


    );
  }
}

export default AddAssignment;